import React from 'react';

import myNameIsImg from "../../../../Assets/my_name_is.png";
import myFamilyImg from "../../../../Assets/my_family.png";
import FavThingsImg from "../../../../Assets/fav_things.png";
import HandNoteImg from "../../../../Assets/hand_note.png";
import ThreeThingsImg from "../../../../Assets/three_things.png";
import WantToBeImg from "../../../../Assets/want_to_be.png";
import MyIdolImg from "../../../../Assets/my_idol.png";
import { API_CONFIG } from '../../../../config/api';

const MyNameIsBlock = ({ data }) => (
    <div
        className="relative mb-6"
        style={{ width: "292px", height: "129px" }}
    >
        <div
            style={{
                width: "292px",
                height: "129px",
                backgroundImage: `url(${myNameIsImg})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
            className="absolute top-0 left-0"
        >
            {/* Name Text Overlay */}
            <div
                className="absolute bg-transparent border-none text-black px-2 font-semibold flex items-center"
                style={{
                    top: "45px",
                    left: "15px",
                    width: "170px",
                    height: "32px",
                    fontSize: "13px",
                }}
            >
                {data.name || ''}
            </div>

            {/* Age Text Overlay */}
            <div
                className="absolute bg-transparent border-none text-black px-2 font-semibold flex items-center justify-center"
                style={{
                    top: "90px",
                    left: "54px",
                    width: "76px",
                    height: "20px",
                    fontSize: "12px",
                }}
            >
                {data.age || ''}
            </div>
        </div>
    </div>
);


const HandNoteBlock = ({ data }) => (
    <div
        className="relative mb-6"
        style={{ width: "224px", height: "296px" }}
    >
        <div
            style={{
                width: "224px",
                height: "296px",
                backgroundImage: `url(${HandNoteImg})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
            className="absolute top-0 left-0"
        >
            {/* Thumb: Reads Palm -> Tip (Up-Left) */}
            <div
                className="absolute bg-transparent border-none text-black text-center font-bold flex items-center justify-center"
                style={{
                    top: "165px",
                    left: "-15px",
                    width: "140px", /* Increased width to prevent wrapping */
                    height: "20px",
                    fontSize: "9px",
                    transform: "rotate(-55deg)",
                    transformOrigin: "center",
                    whiteSpace: "nowrap"
                }}
            >
                {data.good_at || ''}
            </div>

            {/* Index: Reads Palm -> Tip (Up-Left) */}
            <div
                className="absolute bg-transparent border-none text-black text-center font-bold flex items-center justify-center"
                style={{
                    top: "100px",
                    left: "20px",
                    width: "140px",
                    height: "20px",
                    fontSize: "9px",
                    transform: "rotate(-75deg)",
                    transformOrigin: "center",
                    whiteSpace: "nowrap"
                }}
            >
                {data.not_good_at || ''}
            </div>

            {/* Middle: Reads Palm -> Tip (Straight Up) */}
            <div
                className="absolute bg-transparent border-none text-black text-center font-bold flex items-center justify-center"
                style={{
                    top: "65px",
                    left: "42px", /* Centered (224/2 - 140/2) */
                    width: "140px",
                    height: "20px",
                    fontSize: "9px",
                    transform: "rotate(-90deg)",
                    transformOrigin: "center",
                    whiteSpace: "nowrap"
                }}
            >
                {data.would_like_to_improve || ''}
            </div>

            {/* Ring: Reads Tip -> Palm (Down-Right) */}
            <div
                className="absolute bg-transparent border-none text-black text-center font-bold flex items-center justify-center"
                style={{
                    top: "100px",
                    right: "20px", /* Using right for better symmetry */
                    width: "140px",
                    height: "20px",
                    fontSize: "9px",
                    transform: "rotate(75deg)", /* Positive rotation reads downwards */
                    transformOrigin: "center",
                    whiteSpace: "nowrap"
                }}
            >
                {data.like_to || ''}
            </div>

            {/* Pinky: Reads Tip -> Palm (Down-Right) */}
            <div
                className="absolute bg-transparent border-none text-black text-center font-bold flex items-center justify-center"
                style={{
                    top: "160px",
                    right: "-15px", /* Using right for better symmetry */
                    width: "140px",
                    height: "20px",
                    fontSize: "9px",
                    transform: "rotate(50deg)", /* Positive rotation reads downwards */
                    transformOrigin: "center",
                    whiteSpace: "nowrap"
                }}
            >
                {data.dont_like_to || ''}
            </div>
        </div>
    </div>
);


const FavThingsBlock = ({ data }) => (
    <div
        className="relative mb-6"
        style={{ width: "259px", height: "328px" }}
    >
        <div
            style={{
                width: "259px",
                height: "328px",
                backgroundImage: `url(${FavThingsImg})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
            className="absolute top-0 left-0"
        >
            {/* Food Text Overlay */}
            <div
                className="absolute bg-transparent border-none text-black px-2 font-semibold flex items-center"
                style={{
                    top: "60px",
                    left: "73px",
                    width: "170px",
                    height: "32px",
                    fontSize: "13px",
                }}
            >
                {data.favourite_foods || ''}
            </div>

            {/* Games Text Overlay */}
            <div
                className="absolute bg-transparent border-none text-black px-2 font-semibold flex items-center"
                style={{
                    top: "150px",
                    left: "80px",
                    width: "120px",
                    height: "20px",
                    fontSize: "12px",
                }}
            >
                {data.favourite_games || ''}
            </div>

            {/* Festivals Text Overlay */}
            <div
                className="absolute bg-transparent border-none text-black px-2 font-semibold flex items-center"
                style={{
                    top: "232px",
                    left: "88px",
                    width: "100px",
                    height: "20px",
                    fontSize: "12px",
                }}
            >
                {data.favourite_festivals || ''}
            </div>
        </div>
    </div>
);

const ThreeThingsBlock = ({ data }) => (
    <div className="relative mb-6">
        <div
            className="absolute top-0 left-0"
            style={{
                width: "277px",
                height: "251px",
                backgroundImage: `url(${ThreeThingsImg})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                pointerEvents: "none",
            }}
        ></div>

        {/* Text area overlay for learning targets */}
        <div
            className="absolute text-black font-medium resize-none bg-transparent font-semibold"
            style={{
                top: "70px",
                left: "30px",
                width: "140px",
                height: "150px",
                fontSize: "13px",
                lineHeight: "18px"
            }}
        >
            {data.learn_targets && data.learn_targets.length > 0 ? (
                data.learn_targets.slice(0, 3).map((target, index) => (
                    <div key={index} className="mb-3">
                        {target}
                    </div>
                ))
            ) : (
                ''
            )}
        </div>
    </div>
);

const WantToBeBlock = ({ data }) => (
    <div
        className="relative mb-6"
        style={{ width: "212px", height: "212px" }}
    >
        <div className="-translate-y-[-40px]">
            <h5 className="font-bold text-sm mb-2">When I grow up I want to be</h5>
        </div>

        <div
            style={{
                width: "212px",
                height: "212px",
                backgroundImage: `url(${WantToBeImg})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
            className="absolute top-0 left-0"
        >
            {/* Text Overlay */}
            <div
                className="absolute bg-transparent border-none text-black px-2 font-semibold flex items-center"
                style={{
                    top: "90px",
                    left: "60px",
                    width: "170px",
                    height: "32px",
                    fontSize: "13px",
                }}
            >
                {data.want_to_be || ''}
            </div>
        </div>
    </div>
);

const MyIdolBlock = ({ data }) => (
    <div
        className="relative mb-6"
        style={{ width: "233px", height: "128px" }}
    >
        <div
            style={{
                width: "233px",
                height: "128px",
                backgroundImage: `url(${MyIdolImg})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
            className="absolute top-0 left-0"
        >
            {/* Text Overlay */}
            <div
                className="absolute bg-transparent border-none text-black px-2 font-semibold flex items-center"
                style={{
                    top: "50px",
                    left: "15px",
                    width: "170px",
                    height: "32px",
                    fontSize: "13px",
                }}
            >
                {data.idol || ''}
            </div>
        </div>
    </div>
);

const API_BASE_URL = API_CONFIG.BASE_URL;

const MyFamilyBlock = ({ data }) => {
    // Handle both relative and absolute URLs
    const getFullImageUrl = (url) => {
        if (!url) return null;
        // If it's already a full URL, return as-is
        if (url.startsWith('http://') || url.startsWith('https://')) {
            return url;
        }
        // Otherwise, prepend the API base URL
        return `${API_BASE_URL}${url}`;
    };

    const imageUrl = getFullImageUrl(data.family_picture_url);

    return (
        <div
            className="relative mb-6"
            style={{ width: "182px", height: "200px" }}
        >
            <div
                style={{
                    width: "182px",
                    height: "156px",
                    backgroundImage: `url(${myFamilyImg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
                className="absolute top-0 left-0"
            >
                {/* Family photo overlay - positioned within the frame */}
                {imageUrl && (
                    <img
                        src={imageUrl}
                        alt="My Family"
                        className="absolute"
                        style={{
                            top: "12px",
                            left: "12px",
                            width: "158px",
                            height: "132px",
                            objectFit: "contain",
                            borderRadius: "4px"
                        }}
                    />
                )}
            </div>
        </div>
    );
};

// Main PartA2 component following Hand.js structure exactly
const PartA2 = ({ data }) => {
    const safeData = data || {};

    return (
        <div
            className="report-page bg-white shadow-lg"
            style={{
                width: '210mm',
                height: '297mm',
                boxSizing: 'border-box',
                margin: '0 auto',
                padding: '15mm 20mm',
                fontFamily: '"Comic Sans MS", "Comic Sans", cursive',
                color: '#333',
                position: 'relative',
                overflow: 'hidden'
            }}
        >
            {/* Title */}
            <h1 className="text-center text-orange-500 font-bold text-3xl mb-4">
                PART A (2)
            </h1>

            {/* Grid layout exactly like Hand.js */}
            <div className="grid grid-cols-2 h-screen">
                {/* Left Column */}
                <div className="flex flex-col items-end pt-4 bg-white">
                    {/* My Name Is Block */}
                    <MyNameIsBlock data={{
                        name: safeData.name || '',
                        age: safeData.age_years || ''
                    }} />

                    {/* Hand Note Block */}
                    <div className="-translate-x-[55px] -translate-y-[-20px]">
                        <HandNoteBlock data={{
                            good_at: safeData.good_at || '',
                            not_good_at: safeData.not_good_at || '',
                            would_like_to_improve: safeData.would_like_to_improve || '',
                            like_to: safeData.like_to || '',
                            dont_like_to: safeData.dont_like_to || ''
                        }} />
                    </div>

                    {/* Want To Be Block */}
                    <div className="-translate-x-[55px] -translate-y-[20px]">
                        <WantToBeBlock data={{
                            want_to_be: safeData.want_to_be || ''
                        }} />
                    </div>

                    {/* My Idol Block */}
                    <div className="-translate-x-[55px] -translate-y-[55px]">
                        <MyIdolBlock data={{
                            idol: safeData.idol || ''
                        }} />
                    </div>
                </div>

                {/* Right Column */}
                <div className="bg-white p-4">
                    {/* My Family Block */}
                    <div className="-translate-x-[-50px]">
                        <MyFamilyBlock data={{
                            family_picture_url: safeData.family_picture_url || ''
                        }} />
                    </div>

                    {/* Favorite Things Block */}
                    <div className="-translate-y-[20px]">
                        <FavThingsBlock data={{
                            favourite_foods: safeData.favourite_foods || '',
                            favourite_games: safeData.favourite_games || safeData.favourite_sports || '',
                            favourite_festivals: safeData.favourite_festivals || ''
                        }} />
                    </div>

                    {/* Three Things Block */}
                    <div className="-translate-y-[40px]">
                        <ThreeThingsBlock data={{
                            learn_targets: safeData.learn_targets || []
                        }} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PartA2;